export default {
  right: '10%',
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/styles/constants/Coordinates.js